import React from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import styles from "./SupplyContractTerms.module.css";
import externalLinkIcon from "../../assets/external-link.png";
import gasPdf from "../../assets/business-supply-contract-terms-conditions-gas.pdf";
import electricityPdf from "../../assets/business-supply-contract-terms-conditions-electricity.pdf";

const SupplyContractTerms = () => {
  return (
    <div className={styles.container}>
      <Header />
      <div className={styles.headerSection}>
        <h1 className={styles.mainTitle}>
          Supply contract terms and conditions{" "}
          {/* <span className={styles.titleUnderscore}>
            _
          </span> */}
        </h1>
      </div>

      <div className={styles.contentSection}>
        <h4 className={styles.sectionTitle}>Business Gas:</h4>

        <p className={styles.paragraph}>
          <a
            href={gasPdf}
            download="business-supply-contract-terms-conditions-gas.pdf"
            title="Enterprise Gas under 2m therms Terms and Conditions"
            className={styles.pdfLink}
          >
            <span className={styles.pdfIcon}>
              Enterprise Gas under 2m therms Terms and Conditions
            </span>
            <sup>
              <img
                className={styles.externalIcon}
                src={externalLinkIcon}
                alt="this link will open in a new window"
                title="this link will open in a new window"
              />
            </sup>
          </a>
        </p>
        <div className={styles.spacer}></div>
        <h4 className={styles.sectionTitle}>Business Electricity:</h4>

        <p className={styles.paragraph}>
          <a
            href={electricityPdf}
            download="business-supply-contract-terms-conditions-electricity.pdf"
            title="Enterprise Electricity under 5GWh Terms and Conditions"
            className={styles.pdfLink}
          >
            <span className={styles.pdfIcon}>
              Enterprise Electricity under 5GWh Terms and Conditions
            </span>
            <sup>
              <img
                className={styles.externalIcon}
                src={externalLinkIcon}
                alt="this link will open in a new window"
                title="this link will open in a new window"
              />
            </sup>
          </a>
        </p>
        <br />
        <br />

        <p className={styles.smallText}>
          If you have difficulty viewing the Supply Contract Terms and
          Conditions (PDF), please see our{" "}
          <a
            rel="noreferrer"
            href="https://www.engie.co.uk/Deemed-and-Default-Rates"
            target="_blank"
            className={styles.websiteLink}
          >
            website
          </a>{" "}
          for more details.
        </p>
      </div>

      <Footer showAccordions={false} />
    </div>
  );
};

export default SupplyContractTerms;
